export const ISSUE_TYPE_OPTIONS = [
  { value: 'computers', label: 'أجهزة كمبيوتر' },
  { value: 'cameras', label: 'كاميرات' },
  { value: 'fingerprint', label: 'بصمة' },
  { value: 'atm', label: 'ATM' },
  { value: 'network', label: 'شبكة' },
  { value: 'printer', label: 'طابعة' },
  { value: 'internet', label: 'انترنت' },
  { value: 'software', label: 'برامج' },
  { value: 'system', label: 'منظومة' },
  { value: 'domain', label: 'دومين' },
  { value: 'email', label: 'بريد إلكتروني' },
  { value: 'password', label: 'كلمة السر' },
  { value: 'scanner', label: 'ماسح ضوئي' },
  { value: 'cisco_phone', label: 'هاتف سيسكو' }
];

const ISSUE_TYPE_LABELS = ISSUE_TYPE_OPTIONS.reduce((accumulator, option) => {
  accumulator[option.value] = option.label;
  return accumulator;
}, {});

const ISSUE_TYPE_ALIASES = {
  computer: 'computers',
  hardware: 'computers',
  camera: 'cameras',
  cameras: 'cameras',
  fingerprint: 'fingerprint',
  atm: 'atm',
  network: 'network',
  networks: 'network',
  printer: 'printer',
  printers: 'printer',
  internet: 'internet',
  software: 'software',
  system: 'system',
  domain: 'domain',
  email: 'email',
  emails: 'email',
  password: 'password',
  scanner: 'scanner',
  cisco: 'cisco_phone',
  cisco_phone: 'cisco_phone',
  phone: 'cisco_phone'
};

export const normalizeIssueType = (value) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');

  if (!normalized) {
    return null;
  }

  return ISSUE_TYPE_ALIASES[normalized] || (ISSUE_TYPE_LABELS[normalized] ? normalized : null);
};

export const translateIssueType = (value, fallback = 'غير محدد') => {
  const normalized = normalizeIssueType(value);
  if (!normalized) {
    return fallback;
  }

  return ISSUE_TYPE_LABELS[normalized] || fallback;
};

export const translateIssueTypes = (values, fallback = 'غير محدد') => {
  if (!Array.isArray(values) || values.length === 0) {
    return fallback;
  }

  const labels = values
    .map((value) => translateIssueType(value, null))
    .filter(Boolean);

  return labels.length > 0 ? [...new Set(labels)].join('، ') : fallback;
};
